import React, { useState } from 'react'
import PlayListDrawer from 'components_v2/PlayListDrawer/PlayListDrawer'

function usePlaylistDrawer(onSubmitCallback) {
  const [playlistIds, setPlaylistIds] = useState()
  const [isDrawerOpen, setDrawerOpen] = useState(false)
  const [selectedCardData, setSelectedCardData] = useState(null)

  const handleDrawerClose = () => {
    setDrawerOpen(false)
    setSelectedCardData(null)
  }

  const handlePlaylistIconClick = (cardData) => {
    setSelectedCardData(cardData)
    setDrawerOpen(true)
    setPlaylistIds(cardData?.playlistIds)
  }

  const handleSubmit = (updatedData) => {
    if (onSubmitCallback) {
      onSubmitCallback(updatedData, selectedCardData)
    }
    handleDrawerClose()
  }

  const AddToPlaylistDrawer = (
    <PlayListDrawer
      isOpen={isDrawerOpen}
      onClose={() => handleDrawerClose()}
      planEntryId={selectedCardData?.id}
      playlists={playlistIds}
      onSuccess={handleSubmit}
    />
  )

  return {
    handlePlaylistIconClick,
    AddToPlaylistDrawer,
    handleDrawerClose,
    selectedCardData,
    isDrawerOpen
  }
}

export default usePlaylistDrawer
